import React, { useState } from "react";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../../layouts/PageLayout";
import { PageHeader } from "../../../components/v3";
import { AddEditCategory, CategoryList } from "../../../components/library";
import { CREATE_FINANCE_CATEGORY } from "../../../constants";
import { useHasPermission } from "../../../utils";

export const Category = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const hasCreateCategory = useHasPermission(CREATE_FINANCE_CATEGORY);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  // Check if the user has permission to create category
  const buttons = [
    hasCreateCategory && {
      buttonText: "Add Category",
      buttonIcon: Add,
      onClick: handleOpenModal,
    },
  ];

  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader
            // title
            title="Category"
            subtitle={`${totalCount} Categories`}
            // button
            buttons={buttons}
          />
        </Box>

        {/* table section */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <CategoryList totalCount={totalCount} setTotalCount={setTotalCount} onSuccess={handleReload} reloadData={reload} />
        </Box>
      </PageLayout>

      {/* add category modal */}
      <AddEditCategory open={openModal} onClose={handleCloseModal} onSuccess={handleReload} />
    </>
  );
};
